.chart {
  border: 1px solid var(--line);
  border-radius: var(--radius-sharp);
  background: var(--card);
  padding: 0.875rem 1rem;
  display: flex;
  flex-direction: column;
  gap: 0.375rem;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
}

.label {
  font-family: var(--font-mono);
  font-size: var(--text-min-mono);
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--ink-soft);
}

.current {
  font-family: var(--font-display);
  font-size: 1.125rem;
  color: var(--ink);
}

.svg {
  width: 100%;
  height: 3.5rem;
  overflow: visible;
}

.baseline {
  stroke: var(--line);
  stroke-width: 1;
}

.line {
  fill: none;
  stroke: var(--cy-500);
  stroke-width: 1.5;
  stroke-linejoin: round;
  stroke-linecap: round;
}

.anomaly {
  fill: var(--warn);
}

.hit {
  cursor: pointer;
}

.hit:hover {
  fill: color-mix(in srgb, var(--cy-500) 8%, transparent);
}
